import {GenexLMSModel} from "@/models/lms/GenexLMSModel";
import Quiz from "@/models/lms/Quiz";
import Answer from "@/models/lms/Answer";
import UserAnswer from "@/models/lms/UserAnswer";

export default class Question extends GenexLMSModel {
    static entity = 'questions'

    static fields() {
        return {
            type: this.attr('questions'),
            id: this.attr(null),
            order: this.attr(null),
            quiz_id: this.attr(null),
            quiz: this.belongsTo(Quiz, 'quiz_id'),
            name: this.attr(null),
            question: this.attr(null),
            image: this.attr(null),
            grade: this.attr(null),
            answers:this.hasMany(Answer,'question_id'),
            user_answer:this.belongsTo(UserAnswer,'question_id'),
            randomise_answer_order: this.attr(0),
            question_type_id: this.attr(null),
        }
    }
}
